import React from 'react';
import PageLayout from "../../components/page-layout";
import NewUserFrom from "../../components/new-user-form";
import Grid from "@material-ui/core/Grid";
import InsertDeviceForm from '../../components/insert-device-form';

export default function InsertDevice() {

    return (
        <PageLayout pageTitle="افزودن دستگاه">
            <Grid container justifyContent="center">
                <Grid item xs={12} sm={12} md={10}>
                    <InsertDeviceForm />
                </Grid>
            </Grid>
        </PageLayout>
    );
}

